// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__DZ-v2","secondRow":"Footer_secondRow__mlsuy","firstRow":"Footer_firstRow__1XXj4","thirdRow":"Footer_thirdRow__uSIOU"};